import './polyfills';

import './utils/lazyload';
import './utils/toggle';

import './preact/store';
import './preact/app-renderer';